import axios from 'axios';
import InfiniteLoading from 'vue-infinite-loading';
import helper from '~/helper';
import lottiePlayerMixin from "../mixins/lottiePlayerMixin";

export default {
    name: 'VoucherList',
    mixins: [lottiePlayerMixin],
    components: {
        InfiniteLoading,
    },
    props: {
        city: {
            type: String,
            default: null,
        },
        categories: {
            type: Array,
            default: () => [],
        },
        selectedRubricSlug: {
            type: String,
            default: () => null,
        },
        selectedSubRubricSlug: {
            type: String,
            default: () => null,
        },
        currentPage: {
            type: Number,
            default: 0,
        },
        giftCardActivated: {
            type: Object,
            default: () => null,
        },
    },
    data() {
        return {
            vouchers: [],
            page: this.currentPage + 1,
            selectedCategorySlug: this.selectedRubricSlug,
            selectedSubCategorySlug: this.selectedSubRubricSlug,
            infiniteId: +new Date(),
            isHeadPromoVisible: false,
            info: null,
        }
    },
    computed: {
        subCategories() {
            if (this.selectedCategorySlug) {
                const selectedCategory = this.categories.find(item => item.slug === this.selectedCategorySlug);
                if (selectedCategory) {
                    return [
                        ...selectedCategory.children,
                        { slug: null, name: 'Alle' },
                    ];
                }
            }

            return [];
        },
    },
    watch: {
        selectedCategorySlug() {
            this.filterCategories();
            this.changeMetaTitle();
        },
        selectedSubCategorySlug() {
            this.filterCategories();
            this.changeMetaTitle();
        },
        info() {
            this.changeMetaTitle();
        }
    },
    mounted() {
        if (this.giftCardActivated) {
            this.$swal({
                iconHtml: '<lottie-player src="/images/animations/success.json" background="transparent" speed="1" style="width: 100px; height: 100px;" autoplay></lottie-player>',
                title: 'Herzlichen Glückwunsch',
                html: `Geschenkkarte <code>#${this.giftCardActivated.number}</code> wurde am <code>${helper.formatDate(this.giftCardActivated.activated_at)}</code> Uhr aktiviert.`,
            });
        }
        if (window.innerWidth >= 1200) {
            this.isHeadPromoVisible = true; // Если ширина окна больше 1200 пикселей, открыть аккордеон
        }
    },
    methods: {
        infiniteHandler($state) {
            axios.get(
                this.route('app_api_vouchers', {
                    city: this.city,
                    category: this.selectedCategorySlug,
                    subCategory: this.selectedSubCategorySlug,
                    page: this.page,
                }, false),
                { baseURL: '' },
            ).then(({ data }) => {
                if (data.data.length) {
                    this.page += 1;
                    this.vouchers.push(...data.data);
                    $state.loaded();
                } else {
                    if (this.page > 1) {
                        $state.loaded();
                    }
                    $state.complete();
                }
            });
        },
        changeCategory(slug, isDropDown = false) {
            if (!isDropDown) {
                this.selectedCategorySlug = this.selectedCategorySlug === slug ? null : slug;
            }
            this.selectedSubCategorySlug = null;
        },
        changeSubCategory(slug) {
            this.selectedSubCategorySlug = slug;
        },
        clearFilter() {
            this.selectedCategorySlug = null;
            this.selectedSubCategorySlug = null;
        },
        filterCategories() {
            const elements = document.getElementsByClassName('preloadVoucher');
            while (elements.length > 0) {
                elements[0].parentNode.removeChild(elements[0]);
            }

            if (this.selectedCategorySlug || this.selectedSubCategorySlug) {
                axios.get(
                    this.route('app_api_vouchers_info', {
                        city: this.city,
                        category: this.selectedCategorySlug,
                        subCategory: this.selectedSubCategorySlug,
                    }, false),
                    { baseURL: '' },
                ).then(({ data }) => {
                    this.info = data;
                });
            }

            history.pushState(null, '', this.route('vouchers.list', {
                city: this.city,
                rubric: this.selectedCategorySlug,
                subRubric: this.selectedSubCategorySlug || undefined,
            }, false));

            this.page = 1;
            this.vouchers = [];
            this.infiniteId += 1;
        },
        changeMetaTitle() {
            document.title = this.info?.meta_title
                ?? this.subCategories.find(s => (s.slug !== null) && (s.slug === this.selectedSubCategorySlug))?.name
                ?? this.categories.find(c => (c.slug !== null) && (c.slug === this.selectedCategorySlug))?.name
                ?? window.config.meta_title
                ?? 'Stadtgespräch';
        },
    },
}
